exports.default = {
  'create_agent': '新建智能体',
  'edit_agent': '编辑智能体',
  'submit_failed': '保存失败，输入已保留，请重试',
  'avatar_upload_failed': '头像上传失败，请重试',
  'agent_name': '智能体名称',
  'agent_name_placeholder': '请输入智能体名称',
  'agent_function_intro': '智能体功能介绍',
  'agent_function_intro_placeholder': '请输入智能体功能介绍',
  'get_started': '开始新建',
  'avatar': '头像',
  'input_brief': '请输入智能体简介和使用引导',
  'edit_avatar': '修改头像',
  'greetings': '你好！',
  'greetings_promtp': '问候语',
  'greetings_promtp_placeholder': '请输入智能体简介和使用引导',
  'ai_model': 'AI模型',
  'select': '请选择',
  'brief': '简介',
  'leading_questions': '回答完毕会有引导问题',
  'citing_sources': '引用来源',
  'citing_sources_desc': '开启后，AI回答时将显示引用来源文档',
  'markdown_desc': '开启后，内容支持Markdown格式展示',
  'data_source': '数据来源',
  'set_model_context': '设置模型上下文',
  'set_model_context_desc': '开启后，AI在问答时，将有权限访问指定的项目内容作为参考依据回答',
  'confirm': '确认',
  'confirm_upload': '确认上传',
  'input_prompt': '请输入模型提示语，可以用于设定模型身份以及指令要求',
  'return': '返回',
  'opening_greetings': '开场白',
  'auto_generate': '自动生成',
  'crop_image': '剪切图片',
  'model_parameters': '模型参数',
  'opening_greetings_placeholder': '在每次对话开始时发送此消息，让智能体主动说第一段话可以拉近与用户间的距离',
  'next_question_advise': '下一步问题建议',
  'next_question_advise_desc': '在AI回复后，为用户提供 3 条输入建议',
  'preview_and_debug': '预览与调试',
  'suggestion': '建议',
  'suggestion_desc': '我们建议使用结构化提示来创建智能体的角色和预提示。结构化的提示更易于阅读，可以提高回答效率，并使回答效果体验更好。',
  'copy': '复制',
  'prompt_optimize': '提示词优化',
  'balance': '平衡',
  'originality': '创意',
  'accurate': '精确',
  'custom': '自定义',
  'chat_enhancement': '聊天增强',
  'please_input_name': '请输入名称',
  'please_input_brief': '请输入简介',
  'please_input_prompt': '请输入模型提示语，可以用于设定模型身份以及指令要求',
  'retry': '重试',
  'use': '使用',
  'greetings_optimize': '开场白优化',
  'unpublished_prompt': '本次创建未保存，请确认是否离开！',
  'prompt': '提示',
  'need_crop_image': '是否需要剪切图片？',
  'crop': '剪切',
  'release': '发布',
  'confirm_leave': '确认离开',
  'upload_without_crop': '不剪切直接上传',
  'upload_image': '上传图片',
  'name_required': '请输入智能体名称',
  'avatar_required': '请上传头像',
  'intro_required': '请输入功能介绍',
  'save_success': '保存成功',
  'image_type_error': '图片类型必须是：gif,jpeg,jpg,png,bmp中的一种',
  'form_not_complete': '表单填写不完整，请检查后重新提交！',
  'under_development': '正在开发中...',
  'agent_settings': '智能体设置',
  'integration': '连接集成',
  'data_analysis': '数据分析',
  'user_feedback': '用户反馈',
  'member_settings': '成员设置',
  'agent_creation': '智能体创建',
  'choose_template': '选择模板',
  'empty_template': '空白模板',
  'empty_template_desc': '从零开始创建你的智能体',
  'choose_model': '选择模型',
  'basic_info': '基本信息',
  'agent_desc': '智能体描述',
  'agent_desc_placeholder': '请输入智能体描述',
  'agent_avatar': '智能体头像',
  'upload_avatar': '上传头像',
  'go_chat': '去聊天',
  'continue_modify': '继续修改',
  'release_success': '发布成功！',
  'setting': '设置',
  'randomness': '随机性',
  'randomness_tip': '调整AI回答的创造性和多样性，值越大回答越多样',
  'configure_agent': '配置智能体',
  'stable': '稳定',
  'neutral': '中立',
  'prompt_tips': 'Prompt提示词',
  'random': '随机',
  'view_reference_example': '查看参考示例',
  'optimize': '一键优化',
  'prompt_placeholder': '请输入智能体提示词，如：你是一个专业的Java开发工程师，擅长Spring Boot开发...',
  'save_failed': '保存失败，缺少必备的配置信息，请检查！',
  'new_conversation': '新的对话',
  'debug_mode_not_share': '调试模式不允许分享',
  'agent_prompt': '智能体提示词',
  'agent_prompt_tip': '这里可以详细描述你的智能体，比如需要扮演什么角色，擅长什么，应该如何回答问题等，所有对话都将基于此提示词进行。',
  'agent_prompt_placeholder': '请输入智能体提示词，如：你是一个专业的Java开发工程师，擅长Spring Boot开发...',
  'first_question': '首次提问',
  'first_question_tip': '用户第一次和你的智能体对话时，智能体会主动询问此问题',
  'first_question_placeholder': '请输入首次提问，如：你好，我是AI助手，请问有什么可以帮到你的吗？',
  'knowledge_base': '知识库',
  'select_knowledge_base': '选择知识库',
  'knowledge_base_tip': '选择知识库后，用户提问时智能体会在知识库中查找相关信息，并利用这些信息来回答问题',
  'no_knowledge_base': '暂无知识库',
  'create_knowledge_base': '创建知识库',
  'access_permission': '访问权限',
  'team_public': '团队公开',
  'team_public_desc': '所有团队成员可以使用',
  'team_private': '团队私有',
  'team_private_desc': '仅自己和指定成员可以使用',
  'web_public': '网页公开',
  'web_public_desc': '可生成网页链接，任何人可以访问',
  'all_members_tip': '所有成员（{count}）',
  'member_count': '{count}个成员',
  'cancel': '取 消',
  'save': '保 存',
  'create': '创 建',
  'choose_avatar': '选择头像',
  'agent_avatar_tip': '为您的智能体选择一个头像，这将显示在对话界面',
  'use_default_avatar': '使用默认头像',
  'upload_local_image': '上传本地图片',
  'upload_tip': '支持.jpg.jpeg.png.gif格式，大小不超过3MB',
  'model_recommend': '推荐',
  'model_desc': '模型描述',
  'completion_model': '生成式模型',
  'completion_model_desc': '适用于文本生成、内容创作、对话生成等场景',
  'embedding_model': '嵌入式模型',
  'embedding_model_desc': '适用于语义搜索、文本相似度计算等场景',
  'model_provider': '模型提供方',
  'model_parameter': '{parameter}参数',
  'model_training': '{training_date}训练',
  'knowledge_base_selected': '已选择知识库：{name}',
  'agent_name_required': '请输入智能体名称',
  'agent_prompt_required': '请输入智能体提示词',
  'agent_first_question_required': '请输入首次提问',
  'create_success': '创建成功',
  'leave_confirm': '确认离开当前页面吗？您的更改可能未保存。',
  'leave_page': '离开页面',
  'stay_on_page': '留在页面',
  'edit_members': '编辑成员',
  'member_list': '成员列表',
  'member_count_tip': '已选择{count}个成员',
  'search_member': '搜索成员',
  'all_members': '全部成员',
  'selected_members': '已选成员',
  'agent_link': '智能体链接',
  'link_tip': '通过以下链接，您可以在任何地方分享和使用您的智能体，任何人都可以访问和使用',
  'page_link': '页面链接',
  'scan_qrcode': '扫描二维码',
  'embed_code': '嵌入代码',
  'embed_tip': '将此代码嵌入您的网站，即可在网站上使用您的智能体',
  'embed_code_copied': '嵌入代码已复制',
  'link_copied': '链接已复制',
  'close': '关 闭',
  'member_management': '成员管理',
  'member_search_placeholder': '搜索成员姓名',
  'add_member': '添加成员',
  'name': '姓名',
  'permission': '权限',
  'operation': '操作',
  'remove': '移除',
  'add_new_member': '添加新成员',
  'search_by_name': '搜索成员姓名',
  'no_results': '暂无搜索结果',
  'admin': '管理员',
  'editor': '编辑者',
  'viewer': '观看者',
  'team_owner': '团队所有者',
  'team_admin': '团队管理员',
  'agent_owner': '智能体所有者',
  'remove_confirm': '确定要移除该成员吗？',
  'remove_success': '成员移除成功',
  'add_success': '成员添加成功',
  'permission_update_success': '权限更新成功',
  'agent_setting': '智能体设置',
  'model_setting': '模型设置',
  'reset_setting': '重置设置',
  'setting_reset_confirm': '确定要重置所有设置吗？',
  'settings_reset_success': '设置已重置',
  'delete_agent': '删除智能体',
  'delete_agent_confirm': '确定要删除此智能体吗？此操作不可撤销。',
  'delete_success': '删除成功',
  'agent_deleted': '智能体被删除',
  'agent_disabled': '智能体被下架',
  'get_link': '获取链接',
  'advanced_settings': '高级设置',
  'context_window': '上下文窗口',
  'context_window_tip': '设置智能体能够"记住"的消息数量。较大的值会让智能体记住更多历史消息，但也会增加API调用成本。',
  'message_count': '{count}条消息',
  'temperature': '随机性',
  'temperature_tip': '控制输出的随机性。较低的值使输出更确定，较高的值使输出更多样化和创造性。',
  'top_p': '核采样',
  'top_p_tip': '控制模型在生成每个标记时考虑的词汇概率质量。较低的值使输出更确定，较高的值使输出更多样化。',
  'max_tokens': '单次回复限制',
  'max_tokens_tip': '控制模型在每次回复中最多生成的标记数量。较大的值允许模型生成更长的回复。',
  'tokens_count': '{count}个标记',
  'presence_penalty': '话题新鲜度',
  'presence_penalty_tip': '控制模型重复已出现的标记的倾向。较高的正值会惩罚模型重复已出现的标记。',
  'frequency_penalty': '频率惩罚度',
  'frequency_penalty_tip': '控制模型重复已频繁出现的标记的倾向。较高的正值会惩罚模型重复频繁出现的标记。',
  'points_per_request': '{points} 积分/次'
}
